import { InjectionToken } from '@angular/core';

export const SERVE_PORT = new InjectionToken<number>('SERVE_PORT');
